export default {"src":"/_next/static/media/empty-state-big.7310b448.svg","height":140,"width":147,"blurWidth":0,"blurHeight":0};